import { hasAccesPermits } from 'core'
import React, { useMemo } from 'react'
import KindleLmpDa from './KindleLmpDA'
import KindleLmpRT from './KindleLmpRT'
import Generation from './Generation'
import DaAward from './DaAward'
import Fuel from './Fuel'
import KindleDAtaImportLog from './KindleDataImportLog'
import * as ScreenPermissions from 'core/EventActions'

import { Route } from 'react-router-dom'
import { message } from 'antd'

export const saveDataMessage = _ => {
  message.info(
    'Remote data Retrieval in progress.  Depending on the amount of data being transferred, it may take minutes to complete.'
  )
  message.info('Please check the status on the Data Import Status screen.')

  // message.info('Data saved')
}

const KindleContainer = ({ actionPermits, envConfig }) => {
  const daLMP = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_DA_LMP,
          ScreenPermissions.KINDLE_MYSQL_DA_LMP_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const rtLMP = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_RT_LMP,
          ScreenPermissions.KINDLE_MYSQL_RT_LMP_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const generation = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_GENERATION_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_GENERATION_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const daAward = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_DA_AWARD_ADMIN,
          ScreenPermissions.KINDLE_MYSQL_DA_AWARD_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const fuelPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.KINDLE_MYSQL_FUEL_READ,
          ScreenPermissions.KINDLE_MYSQL_FUEL_ADMIN,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      {daLMP && (
        <Route
          key="ms-da-lmp"
          exact
          path="/ms-da-lmp"
          component={KindleLmpDa}
        />
      )}
      {rtLMP && (
        <Route
          key="ms-rt-lmp"
          exact
          path="/ms-rt-lmp"
          component={KindleLmpRT}
        />
      )}
      {generation && (
        <Route
          key="generation"
          exact
          path="/ms-generation"
          component={Generation}
        />
      )}
      {daAward && (
        <Route key="daaward" exact path="/ms-daaward" component={DaAward} />
      )}
      {fuelPermission && (
        <Route key="ms-fuel" exact path="/ms-fuel" component={Fuel} />
      )}
      {(daLMP || rtLMP || daAward || generation || fuelPermission) && (
        <Route
          key="ms-data-log"
          exact
          path="/ms-data-log"
          component={KindleDAtaImportLog}
        />
      )}
    </React.Fragment>
  )
}

export { KindleContainer, KindleLmpDa }
